import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Hero from './components/Hero';
import Introduction from './components/Introduction';
import InfrastructureStack from './components/InfrastructureStack';
import CoreServices from './components/CoreServices';
import WhyNamvoro from './components/WhyNamvoro';
import CustomerReview from './components/CustomerReview';
import ConsultationForm from './components/ConsultationForm';
import ClientTrust from './components/ClientTrust';
import SocialProfiles from './components/SocialProfiles';
import LinkBuilding from './components/LinkBuilding';
import Footer from './components/Footer';
import AccessibilityWidget from './components/AccessibilityWidget';
import Analytics from './components/Analytics';
import SEOHead from './components/SEOHead';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import SecurityArchitecture from './pages/SecurityArchitecture';
import './App.css';

// ScrollToTop component to handle automatic scrolling
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when route changes
    if (typeof window !== 'undefined') {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }, [pathname]);

  return null;
};

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen bg-slate-50">
          <ScrollToTop />
          <Analytics />
          <Header />
          <AccessibilityWidget />
          <Routes>
            <Route path="/" element={
              <>
                <SEOHead />
                <Hero />
                <Introduction />
                <InfrastructureStack />
                <CoreServices />
                <WhyNamvoro />
                <CustomerReview />
                <ConsultationForm />
                <ClientTrust />
                <SocialProfiles />
                <LinkBuilding />
              </>
            } />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/security-architecture" element={<SecurityArchitecture />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;